import React from "react";
import { Field } from "./UI";

export default function ReadOnlyField({ label, id, value, fallback = "Not set", masked = false }) {
  const missing = value === undefined || value === null || value === "";
  const displayValue = missing ? fallback : masked ? "••••••••" : String(value);

  return (
    <Field label={label} htmlFor={id}>
      <input id={id} className="launcher-readonly" value={displayValue} readOnly />
    </Field>
  );
}
